<template>
  <ContentWrap title="运费模板管理">
    <template #header>
      <el-button type="primary" plain @click="openForm('create')">
        <Icon icon="ep:plus" class="mr-5px" />新增
      </el-button>
    </template>

    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="模板名称" min-width="160" prop="name" />
      <el-table-column label="计费方式" width="100" prop="chargeMode">
        <template #default="{ row }">
          <dict-tag :type="DICT_TYPE.EXPRESS_CHARGE_MODE" :value="row.chargeMode" />
        </template>
      </el-table-column>
      <el-table-column label="排序" width="80" prop="sort" />
      <el-table-column label="创建时间" width="170" prop="createTime" :formatter="dateFormatter" />
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openForm('update', row.id)">编辑</el-button>
          <el-button link type="danger" @click="handleDelete(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-model:limit="queryParams.pageSize" v-model:page="queryParams.pageNo" :total="total" @pagination="getList" />
  </ContentWrap>

  <ExpressTemplateForm ref="formRef" @success="getList" />
</template>

<script lang="ts" setup>
import { DICT_TYPE } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import * as ExpressTemplateApi from '@/api/merchant/delivery/expressTemplate'
import ExpressTemplateForm from './ExpressTemplateForm.vue'

defineOptions({ name: 'MerchantExpressTemplate' })

const message = useMessage()

const loading = ref(false)
const list = ref<ExpressTemplateApi.DeliveryExpressTemplateVO[]>([])
const total = ref(0)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10
})

const formRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await ExpressTemplateApi.getDeliveryExpressTemplatePage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const openForm = (type: string, id?: number) => {
  formRef.value.open(type, id)
}

const handleDelete = async (id: number) => {
  try {
    await message.delConfirm()
    await ExpressTemplateApi.deleteDeliveryExpressTemplate(id)
    message.success('删除成功')
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
})
</script>
